import script from "./SiteRichText.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteRichText.vue?vue&type=script&setup=true&lang=ts"

import "./SiteRichText.vue?vue&type=style&index=0&id=82bd9efc&lang=scss"

const __exports__ = script;

export default __exports__